import axios from 'axios';

// export const API_URL = 'http://127.0.0.1:8000';
export const API_URL = 'https://api.apexqbank.ru';




// Проверка токена
export const APIVerifyToken = async (token) => {
    try {
        const response = await axios.get(`${API_URL}/auth/verify-token/`, getAuthConfig(token));
        return response.data;
    } catch (error) {
        handleApiError(error);
        throw error;
    }
};

// Статус 5-дневного триала (state, days_left, ends_at, russian_content_access)
export const APIGetTrialStatus = async (token) => {
    try {
        const response = await axios.get(`${API_URL}/auth/trial-status/`, getAuthConfig(token));
        return response.data;
    } catch (error) {
        handleApiError(error);
        throw error;
    }
};

// Хелпер: распознать 403-ответ с trial_locked от бэкенда. Используется везде,
// где фронт вызывает гейтированный эндпоинт (generate_test, module_detail,
// plan task/start-test и т.п.). Возвращает либо null, либо объект
// { trial_state, message } для открытия UpgradeModal.
export const detectTrialLocked = (error) => {
    const data = error?.response?.data;
    if (!data) return null;
    if (data.error === 'trial_locked' || data.trial_locked === true) {
        return {
            trial_state: data.trial_state || 'active_trial',
            message: data.message || 'Этот раздел доступен только на платном тарифе.',
        };
    }
    return null;
};

// Авторизация
export const APILogin = async (email, password) => {
  try {
    const response = await axios.post(`${API_URL}/auth/login/`, {
      email,
      password
    });
    return response.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};

// Регистрация пользователя
export const APIRegister = async (userData) => {
  try {
    const response = await axios.post(`${API_URL}/auth/register/`, userData);
    return response.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};

// Выход из системы
export const APILogout = () => {
  // Cookies.remove('authToken');
  // Можно добавить запрос на сервер для инвалидации токена
};

// ======= Данные категорий и контента =======

// Получение категорий тестов и его дерева
export const APIGetContentTree = async (token) => {
  try {
    const response = await axios.get(`${API_URL}/content/tree/`, getAuthConfig(token));
    return response.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};

// Админские функции для управления категориями
export const APIGetAdminCategoriesTree = async (token) => {
  try {
    const response = await axios.get(`${API_URL}/content/tree/`, getAuthConfig(token));
    return response.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};

export const APICreateCategory = async (token, categoryData) => {
  try {
    const response = await axios.post(`${API_URL}/content/admin/categories/`, categoryData, getAuthConfig(token));
    return response.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};

export const APIUpdateCategory = async (token, categoryId, categoryData) => {
  try {
    const response = await axios.put(`${API_URL}/content/admin/categories/${categoryId}/`, categoryData, getAuthConfig(token));
    return response.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};

export const APIDeleteCategory = async (token, categoryId) => {
  try {
    const response = await axios.delete(`${API_URL}/content/admin/categories/${categoryId}/delete/`, getAuthConfig(token));
    return response.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};

// Админские функции для управления вопросами
export const APIGetAllQuestions = async (token, page = 1, pageSize = 50) => {
  try {
    const response = await axios.get(`${API_URL}/content/admin/questions/all/`, {
      ...getAuthConfig(token),
      params: { page, page_size: pageSize }
    });
    return response.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};

export const APIGetQuestionForEdit = async (token, questionId) => {
  try {
    const response = await axios.get(`${API_URL}/content/admin/questions/${questionId}/`, getAuthConfig(token));
    return response.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};

export const APIUpdateQuestion = async (token, questionId, questionData) => {
  try {
    const response = await axios.put(`${API_URL}/content/admin/questions/${questionId}/update/`, questionData, getAuthConfig(token));
    return response.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};

// Админские функции для управления вопросами
export const APICreateQuestion = async (token, questionData) => {
  try {
    const response = await axios.post(`${API_URL}/content/admin/questions/`, questionData, getAuthConfig(token));
    return response.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};

export const APIDeleteQuestion = async (token, questionId) => {
  try {
    const response = await axios.delete(`${API_URL}/content/admin/questions/${questionId}/delete/`, getAuthConfig(token));
    return response.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};

export const APIFlagQuestion = async (token, questionId, note = '', flag = null) => {
  try {
    const response = await axios.post(
      `${API_URL}/content/admin/questions/${questionId}/flag-review/`,
      { note, flag },
      getAuthConfig(token)
    );
    return response.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};

export const APIGetFlaggedQuestions = async (token) => {
  try {
    const response = await axios.get(
      `${API_URL}/content/admin/questions/flagged/`,
      getAuthConfig(token)
    );
    return response.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};

export const APIUploadQuestionImage = async (token, imageFile) => {
  try {
    const formData = new FormData();
    formData.append('image', imageFile);

    const response = await axios.post(`${API_URL}/content/admin/questions/upload-image/`, formData, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'multipart/form-data'
      }
    });
    return response.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};

// Импорт вопросов из CSV
export const APIImportQuestionsCSV = async (token, csvFile, categoryIds = []) => {
  try {
    const formData = new FormData();
    formData.append('csv_file', csvFile);
    if (categoryIds.length > 0) {
      formData.append('category_ids', categoryIds.join(','));
    }

    const response = await axios.post(`${API_URL}/content/admin/questions/import-csv/`, formData, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'multipart/form-data'
      }
    });
    return response.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};

// Массовое обновление категорий вопросов
export const APIBulkUpdateQuestionsCategory = async (token, questionIds, categoryIds, action = 'replace') => {
  try {
    const response = await axios.post(`${API_URL}/content/admin/questions/bulk-update-category/`, {
      question_ids: questionIds,
      category_ids: categoryIds,
      action: action
    }, getAuthConfig(token));
    return response.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};

// Изменение порядка категорий
export const APIReorderCategories = async (token, orders) => {
  try {
    const response = await axios.post(`${API_URL}/content/admin/categories/reorder/`, {
      orders: orders
    }, getAuthConfig(token));
    return response.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};

// ===== Анализ дубликатов =====

// Запуск анализа дубликатов
export const APIAnalyzeDuplicates = async (token, batchSize = 50, categoryIds = []) => {
  try {
    const response = await axios.post(`${API_URL}/content/admin/duplicates/analyze/`, {
      batch_size: batchSize,
      category_ids: categoryIds
    }, {
      ...getAuthConfig(token),
      timeout: 3600000  // 60 минут для длительного анализа
    });
    return response.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};

// Получение списка дубликатов
export const APIGetDuplicates = async (token, page = 1, pageSize = 50) => {
  try {
    const response = await axios.get(`${API_URL}/content/admin/duplicates/`, {
      ...getAuthConfig(token),
      params: { page, page_size: pageSize }
    });
    return response.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};

// Очистить все метки дубликатов
export const APIClearDuplicates = async (token) => {
  try {
    const response = await axios.post(`${API_URL}/content/admin/duplicates/clear/`, {}, getAuthConfig(token));
    return response.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};

// Скрыть все дубликаты
export const APIHideAllDuplicates = async (token) => {
  try {
    const response = await axios.post(`${API_URL}/content/admin/duplicates/hide-all/`, {}, getAuthConfig(token));
    return response.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};

// Скрыть один дубликат
export const APIHideDuplicate = async (token, questionId) => {
  try {
    const response = await axios.post(`${API_URL}/content/admin/duplicates/${questionId}/hide/`, {}, getAuthConfig(token));
    return response.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};

// Снять метку дубликата с одного вопроса
export const APIUnmarkDuplicate = async (token, questionId) => {
  try {
    const response = await axios.post(`${API_URL}/content/admin/duplicates/${questionId}/unmark/`, {}, getAuthConfig(token));
    return response.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};


// ======== Данные тестов ========

// Создание теста
export const APICreateTest = async (data, token) => {
  try {
    const response = await axios.post(`${API_URL}/testing/generate/`, data, getAuthConfig(token));
    return response.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};

export const APICreateClinicalTest = async (data, token) => {
  try {
    const response = await axios.post(`${API_URL}/testing/generate-clinical/`, data, getAuthConfig(token));
    return response.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};

// Получение тестов пользователя
export const APIGetMyTests = async (token) => {
  try {
    const response = await axios.get(`${API_URL}/testing/my/`, getAuthConfig(token));
    return response.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};

// Получение детальной информации о тесте
export const APIGetTestDetail = async (token, testId) => {
  try {
    const response = await axios.get(`${API_URL}/testing/${testId}/`, getAuthConfig(token));
    return response.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};

// Получение результатов теста
export const APIGetTestResults = async (token, testId) => {
  try {
    const response = await axios.get(`${API_URL}/testing/${testId}/results/`, getAuthConfig(token));
    return response.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};

// Сброс ответа (админ)
export const APIResetAnswer = async (token, testQuestionId) => {
  try {
    const response = await axios.post(`${API_URL}/testing/reset-answer/`, { test_question_id: testQuestionId }, getAuthConfig(token));
    return response.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};

// Отправка ответа на вопрос
export const APISubmitAnswer = async (token, answerData) => {
  try {
    const response = await axios.post(`${API_URL}/testing/submit-answer/`, answerData, getAuthConfig(token));
    return response.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};

// Завершение теста
export const APICompleteTest = async (token, testId) => {
  try {
    const response = await axios.post(`${API_URL}/testing/${testId}/complete/`, {}, getAuthConfig(token));
    return response.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};

// Удаление теста
export const APIDeleteTest = async (token, testId) => {
  try {
    const response = await axios.delete(`${API_URL}/testing/${testId}/delete/`, getAuthConfig(token));
    return response.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};

// Маркировка вопроса
export const APIMarkQuestion = async (token, markData) => {
  try {
    const response = await axios.post(`${API_URL}/testing/mark-question/`, markData, getAuthConfig(token));
    return response.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};


// ===== Пользователи =====

// Админские функции для управления пользователями
export const APIGetAllUsers = async (token, page = 1, pageSize = 50, search = '') => {
  try {
    const params = { page, page_size: pageSize };
    if (search) params.search = search;
    const response = await axios.get(`${API_URL}/auth/admin/users/`, {
      ...getAuthConfig(token),
      params
    });
    return response.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};

export const APIGetUserDetail = async (token, userId) => {
  try {
    const response = await axios.get(`${API_URL}/auth/admin/users/${userId}/`, getAuthConfig(token));
    return response.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};

export const APIUpdateUser = async (token, userId, userData) => {
  try {
    const response = await axios.put(`${API_URL}/auth/admin/users/${userId}/update/`, userData, getAuthConfig(token));
    return response.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};

export const APIDeleteUser = async (token, userId) => {
  try {
    const response = await axios.delete(`${API_URL}/auth/admin/users/${userId}/delete/`, getAuthConfig(token));
    return response.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};

// Функция для создания пользователя
export const APICreateUser = async (token, userData) => {
  try {
    const response = await axios.post(`${API_URL}/auth/admin/users/create/`, userData, getAuthConfig(token));
    return response.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};


// Админ: выдать безлимит по email
export const APIGrantUnlimited = async (token, email, days) => {
  try {
    const response = await axios.post(`${API_URL}/auth/admin/grant-unlimited/`, {
      email,
      days
    }, getAuthConfig(token));
    return response.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};

// Админ: установить дневной лимит пользователю
export const APISetUserLimit = async (token, email, daily_test_limit, daily_module_limit) => {
  try {
    const response = await axios.post(`${API_URL}/auth/admin/set-limit/`, {
      email,
      daily_test_limit,
      daily_module_limit
    }, getAuthConfig(token));
    return response.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};

export const APIGetUserActivity = async (token, userId) => {
  try {
    const response = await axios.get(`${API_URL}/auth/admin/users/${userId}/activity/`, getAuthConfig(token));
    return response.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};

export const APIToggleRussianAccess = async (token, userId) => {
  try {
    const response = await axios.post(`${API_URL}/auth/admin/users/${userId}/toggle-russian/`, {}, getAuthConfig(token));
    return response.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};

// ===== Статистика =====

// Получение данных для главной страницы
export const APIGetHomepageData = async (token) => {
  try {
    const response = await axios.get(`${API_URL}/testing/homepage-data/`, getAuthConfig(token));
    return response.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};

// Получение общей статистики пользователя
export const APIGetUserStatistics = async (token) => {
  try {
    const response = await axios.get(`${API_URL}/testing/statistics/user/`, getAuthConfig(token));
    return response.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};

// Получение детальной статистики по конкретному тесту
export const APIGetTestStatistics = async (token, testId) => {
  try {
    const response = await axios.get(`${API_URL}/testing/statistics/test/${testId}/`, getAuthConfig(token));
    return response.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};

// Получение данных для тепловой карты активности
export const APIGetActivityHeatmap = async (token, year = null) => {
  try {
    const params = {};
    if (year) {
      params.year = year;
    }
    
    const response = await axios.get(`${API_URL}/testing/statistics/heatmap/`, {
      ...getAuthConfig(token),
      params: params
    });
    return response.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};


// ===== Профиль пользователя =====

// Получение профиля
export const APIGetUserProfile = async (token) => {
  try {
    const response = await axios.get(`${API_URL}/auth/profile/`, getAuthConfig(token));
    return response.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};

// Обновление профиля
export const APIUpdateUserProfile = async (token, userData) => {
  try {
    const response = await axios.put(`${API_URL}/auth/profile/`, userData, getAuthConfig(token));
    return response.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};

// Смена пароля
export const APIChangePassword = async (token, passwordData) => {
  try {
    const response = await axios.post(`${API_URL}/auth/profile/change-password/`, passwordData, getAuthConfig(token));
    return response.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};

// Загрузка аватара
export const APIUploadAvatar = async (token, avatarFile) => {
  try {
    const formData = new FormData();
    formData.append('avatar', avatarFile);
    
    const response = await axios.post(`${API_URL}/auth/profile/upload-avatar/`, formData, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'multipart/form-data'
      }
    });
    return response.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};

// Удаление аватара
export const APIDeleteAvatar = async (token) => {
  try {
    const response = await axios.delete(`${API_URL}/auth/profile/delete-avatar/`, getAuthConfig(token));
    return response.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};


// ===== Платежи =====

// Получение тарифов
export const APIGetRates = async (token) => {
  try {
    const response = await axios.get(`${API_URL}/subscriptions/rates/`, getAuthConfig(token));
    return response.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};

// Создание инвойса
export const APICreateInvoice = async (token, rateId) => {
  try {
    const response = await axios.post(`${API_URL}/subscriptions/invoices/create/`, 
      { rate_id: rateId }, 
      getAuthConfig(token)
    );
    return response.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};

// Проверка статуса инвойса
export const APICheckInvoiceStatus = async (token, uuid) => {
  try {
    const response = await axios.get(`${API_URL}/subscriptions/invoices/${uuid}/status/`, getAuthConfig(token));
    return response.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};

// Отмена инвойса
export const APICancelInvoice = async (token, uuid) => {
  try {
    const response = await axios.post(`${API_URL}/subscriptions/invoices/${uuid}/cancel/`, {}, getAuthConfig(token));
    return response.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};

// TG Промо — создание платежа по спеццене
export const APICreateTgPromoInvoice = async (token, period = 1) => {
  try {
    const response = await axios.post(`${API_URL}/subscriptions/tg-promo/create-invoice/`, { period }, getAuthConfig(token));
    return response.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};

// Стандартный тариф — создание платежа (не-подписчики TG)
export const APICreateStandardInvoice = async (token, period = 1) => {
  try {
    const response = await axios.post(`${API_URL}/subscriptions/standard/create-invoice/`, { period }, getAuthConfig(token));
    return response.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};

// Grand Slam тариф - создание платежа (1/3/6/12 мес)
export const APICreateGrandSlamInvoice = async (token, period = 12) => {
  try {
    const response = await axios.post(`${API_URL}/subscriptions/grand-slam/create-invoice/`, { period }, getAuthConfig(token));
    return response.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};

// QBank only — для не-TG юзеров (1/3/6/12 мес). 2490/4990/8990/16990.
export const APICreateQbankInvoice = async (token, period = 1) => {
  try {
    const response = await axios.post(`${API_URL}/subscriptions/qbank/create-invoice/`, { period }, getAuthConfig(token));
    return response.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};

// Админ: список платных пользователей
export const APIGetPaidUsers = async (token) => {
  try {
    const response = await axios.get(`${API_URL}/subscriptions/admin/paid-users/`, getAuthConfig(token));
    return response.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};

// Prodamus — оплата иностранной картой
export const APICreateProdamusInvoice = async (token, period = 1) => {
  try {
    const response = await axios.post(`${API_URL}/subscriptions/prodamus/create-invoice/`, { period }, getAuthConfig(token));
    return response.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};

// Получение информации о платежах пользователя
export const APIGetUserPaymentInfo = async (token) => {
  try {
    const response = await axios.get(`${API_URL}/subscriptions/payment-info/`, getAuthConfig(token));
    return response.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};

// Ручная активация оплаченного тарифа (срок стартует с этого момента)
export const APIActivateInvoice = async (token, uuidPay) => {
  try {
    const response = await axios.post(
      `${API_URL}/subscriptions/invoices/${uuidPay}/activate/`, {}, getAuthConfig(token)
    );
    return response.data;
  } catch (error) {
    return error?.response?.data || { success: false, error: 'Ошибка активации' };
  }
};

// Заморозка подписки — статус (доступна ли, заморожена ли сейчас)
export const APIGetFreezeStatus = async (token) => {
  try {
    const response = await axios.get(`${API_URL}/subscriptions/freeze-status/`, getAuthConfig(token));
    return response.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};

// Заморозка подписки — активация (days = 7..30)
export const APIFreezeSubscription = async (token, days) => {
  try {
    const response = await axios.post(`${API_URL}/subscriptions/freeze/`, { days }, getAuthConfig(token));
    return response.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};


// ===== PDF Question Generator =====

// Upload PDF file
export const APIUploadPDF = async (token, pdfFile) => {
  try {
    const formData = new FormData();
    formData.append('pdf_file', pdfFile);

    const response = await axios.post(`${API_URL}/generator/upload/`, formData, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'multipart/form-data'
      }
    });
    return response.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};

// Analyze PDF pages
export const APIAnalyzePDFPages = async (token, pdfPath, startPage, pageCount) => {
  try {
    const response = await axios.post(`${API_URL}/generator/analyze/`, {
      pdf_path: pdfPath,
      start_page: startPage,
      page_count: pageCount
    }, getAuthConfig(token));
    return response.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};

// Generate questions from chapters
export const APIGenerateQuestions = async (token, chapters, chapterIndices = null) => {
  try {
    const response = await axios.post(`${API_URL}/generator/generate/`, {
      chapters: chapters,
      chapter_indices: chapterIndices
    }, getAuthConfig(token));
    return response.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};

// Import generated questions to QBANK
export const APIImportGeneratedQuestions = async (token, questions, categoryIds = []) => {
  try {
    const response = await axios.post(`${API_URL}/generator/import/`, {
      questions: questions,
      category_ids: categoryIds
    }, getAuthConfig(token));
    return response.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};

// Import to QGen (for review before main bank)
export const APIImportToQgen = async (token, questions, batchTitle = 'PDF Generation') => {
  try {
    const response = await axios.post(`${API_URL}/generator/import-to-qgen/`, {
      questions,
      batch_title: batchTitle,
    }, getAuthConfig(token));
    return response.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};

// Cleanup temporary files
export const APICleanupGenerator = async (token, pdfPath) => {
  try {
    const response = await axios.post(`${API_URL}/generator/cleanup/`, {
      pdf_path: pdfPath
    }, getAuthConfig(token));
    return response.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};

// Auto-loop: batch process PDF pages with automatic import
export const APIGenerateLoop = async (token, pdfPath, startPage, totalPages, batchSize = 5) => {
  try {
    const response = await axios.post(`${API_URL}/generator/generate-loop/`, {
      pdf_path: pdfPath,
      start_page: startPage,
      total_pages: totalPages,
      batch_size: batchSize
    }, {
      ...getAuthConfig(token),
      timeout: 7200000  // 2 hours timeout for long operations
    });
    return response.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};


// ===== Модули =====

// Получение списка модулей
export const APIGetModules = async (token) => {
  try {
    const response = await axios.get(`${API_URL}/modules/`, getAuthConfig(token));
    return response.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};

// Получение детальной информации о модуле
export const APIGetModuleDetail = async (token, moduleId) => {
  try {
    const response = await axios.get(`${API_URL}/modules/${moduleId}/`, getAuthConfig(token));
    return response.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};

// Отметить модуль как прочитанный
export const APIMarkModuleRead = async (token, moduleId) => {
  try {
    const response = await axios.post(`${API_URL}/modules/${moduleId}/mark-read/`, {}, getAuthConfig(token));
    return response.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};

// Практика: создать тест из категории модуля
export const APIPracticeModule = async (token, moduleId) => {
  try {
    const response = await axios.post(`${API_URL}/modules/${moduleId}/practice/`, {}, getAuthConfig(token));
    return response.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};

export const APIGetModuleRecentTests = async (token, moduleId) => {
  try {
    const response = await axios.get(`${API_URL}/modules/${moduleId}/recent-tests/`, getAuthConfig(token));
    return response.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};

// Админ: создать модуль
export const APICreateModule = async (token, moduleData) => {
  try {
    const response = await axios.post(`${API_URL}/modules/admin/create/`, moduleData, getAuthConfig(token));
    return response.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};

// Админ: обновить модуль
export const APIUpdateModule = async (token, moduleId, moduleData) => {
  try {
    const response = await axios.put(`${API_URL}/modules/admin/${moduleId}/update/`, moduleData, getAuthConfig(token));
    return response.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};

// Админ: удалить модуль
export const APIDeleteModule = async (token, moduleId) => {
  try {
    const response = await axios.delete(`${API_URL}/modules/admin/${moduleId}/delete/`, getAuthConfig(token));
    return response.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};

// Админ: AI генерация содержания модуля
export const APIGenerateModuleContent = async (token, data) => {
  try {
    const response = await axios.post(`${API_URL}/modules/admin/generate/`, data, {
      ...getAuthConfig(token),
      timeout: 120000  // 2 минуты для AI генерации
    });
    return response.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};


// Админ: расширить содержание модуля (добавить объяснения)
export const APIExpandModuleContent = async (token, moduleId) => {
  try {
    const response = await axios.post(`${API_URL}/modules/admin/${moduleId}/expand/`, {}, {
      ...getAuthConfig(token),
      timeout: 180000  // 3 минуты для расширения
    });
    return response.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};

// Админ: пакетная генерация модулей из PDF
export const APIBatchGenerateModules = async (token, data) => {
  try {
    const response = await axios.post(`${API_URL}/modules/admin/generate-batch/`, data, {
      ...getAuthConfig(token),
      timeout: 600000  // 10 минут для пакетной генерации
    });
    return response.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};

// Админ: пакетная генерация Explanations
export const APIBatchExpandModules = async (token, data) => {
  try {
    const response = await axios.post(`${API_URL}/modules/admin/batch-expand/`, data, {
      ...getAuthConfig(token),
      timeout: 600000  // 10 минут
    });
    return response.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};

// Админ: статистика пустых/заполненных модулей
export const APIGetEmptyModulesStats = async (token) => {
  try {
    const response = await axios.get(`${API_URL}/modules/admin/empty-stats/`, getAuthConfig(token));
    return response.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};


// Админ: доступные категории для перемещения модуля
export const APIGetAvailableCategories = async (token, moduleId) => {
  try {
    const response = await axios.get(
      `${API_URL}/modules/admin/available-categories/?exclude_module_id=${moduleId}`,
      getAuthConfig(token)
    );
    return response.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};

// Админ: переместить модуль в другую категорию
export const APIMoveModule = async (token, moduleId, targetCategoryId) => {
  try {
    const response = await axios.post(
      `${API_URL}/modules/admin/${moduleId}/move/`,
      { target_category_id: targetCategoryId },
      getAuthConfig(token)
    );
    return response.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};


// ===== Discussions =====

export const APIGetQuestionDiscussions = async (token, questionId) => {
  try {
    const response = await axios.get(`${API_URL}/discussions/question/${questionId}/`, getAuthConfig(token));
    return response.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};

export const APICreateDiscussion = async (token, data) => {
  try {
    const response = await axios.post(`${API_URL}/discussions/create/`, data, getAuthConfig(token));
    return response.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};

export const APIDeleteDiscussion = async (token, discussionId) => {
  try {
    const response = await axios.delete(`${API_URL}/discussions/${discussionId}/delete/`, getAuthConfig(token));
    return response.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};

export const APIToggleDiscussionLike = async (token, discussionId) => {
  try {
    const response = await axios.post(`${API_URL}/discussions/${discussionId}/like/`, {}, getAuthConfig(token));
    return response.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};

// ===== Question Reports =====

export const APICreateQuestionReport = async (token, data) => {
  try {
    const response = await axios.post(`${API_URL}/discussions/reports/create/`, data, getAuthConfig(token));
    return response.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};

export const APIGetQuestionReports = async (token, statusFilter = null) => {
  try {
    const params = statusFilter ? { status: statusFilter } : {};
    const response = await axios.get(`${API_URL}/discussions/reports/`, {
      ...getAuthConfig(token),
      params
    });
    return response.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};

export const APIUpdateReportStatus = async (token, reportId, data) => {
  try {
    const response = await axios.put(`${API_URL}/discussions/reports/${reportId}/update/`, data, getAuthConfig(token));
    return response.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};

// ===== Daily Question =====

export const APIGetDailyQuestion = async (token) => {
  try {
    const response = await axios.get(`${API_URL}/discussions/daily-question/`, getAuthConfig(token));
    return response.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};

export const APIAnswerDailyQuestion = async (token, data) => {
  try {
    const response = await axios.post(`${API_URL}/discussions/daily-question/answer/`, data, getAuthConfig(token));
    return response.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};

// ===== Leaderboard =====

export const APIGetLeaderboard = async (token, period = 'weekly') => {
    try {
        const response = await axios.get(`${API_URL}/testing/leaderboard/`, {
            ...getAuthConfig(token),
            params: { period }
        });
        return response.data;
    } catch (error) {
        handleApiError(error);
        throw error;
    }
};

// ===== Streak =====

export const APIGetStreak = async (token) => {
  try {
    const response = await axios.get(`${API_URL}/discussions/streak/`, getAuthConfig(token));
    return response.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};

export const APIUpdateDailyGoal = async (token, dailyGoal) => {
  try {
    const response = await axios.put(`${API_URL}/discussions/streak/goal/`, { daily_goal: dailyGoal }, getAuthConfig(token));
    return response.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};


// ===== Onboarding =====

export const APICompleteOnboarding = async (token) => {
  try {
    const response = await axios.post(`${API_URL}/auth/profile/complete-onboarding/`, {}, getAuthConfig(token));
    return response.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};

export const APISaveSurvey = async (token, data) => {
  try {
    const response = await axios.post(`${API_URL}/auth/profile/save-survey/`, data, getAuthConfig(token));
    return response.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};

// Отзыв платного пользователя (оценка + текст + согласие на публикацию)
export const APISubmitPaidFeedback = async (token, data) => {
  try {
    const response = await axios.post(`${API_URL}/auth/paid-feedback/`, data, getAuthConfig(token));
    return response.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};

// Админ: список всех отзывов платных пользователей
export const APIGetPaidFeedbackAdmin = async (token) => {
  try {
    const response = await axios.get(`${API_URL}/auth/admin/paid-feedback/`, getAuthConfig(token));
    return response.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};

export const APIGetOnboardingQuiz = async (token, topic) => {
  try {
    const response = await axios.post(`${API_URL}/testing/onboarding-quiz/`, { topic }, getAuthConfig(token));
    return response.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};

export const APICompleteOnboardingQuiz = async (token, data) => {
  try {
    const response = await axios.post(`${API_URL}/testing/onboarding-quiz/complete/`, data, getAuthConfig(token));
    return response.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};

// ===== Clinical Test =====

export const APIGetClinicalCategories = async (token) => {
  try {
    const response = await axios.get(`${API_URL}/testing/clinical-categories/`, getAuthConfig(token));
    return response.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};

export const APIGenerateClinicalTest = async (token, numQuestions = 10, categoryIds = []) => {
  try {
    const response = await axios.post(
      `${API_URL}/testing/generate-clinical/`,
      { num_questions: numQuestions, category_ids: categoryIds },
      getAuthConfig(token)
    );
    return response.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};

// ===== Documents =====

export const APIGetDocuments = async (token) => {
  try {
    const response = await axios.get(`${API_URL}/documents/`, getAuthConfig(token));
    return response.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};

export const APIDownloadDocument = async (token, docId) => {
  try {
    const response = await axios.get(`${API_URL}/documents/${docId}/download/`, {
      ...getAuthConfig(token),
      responseType: 'blob',
    });
    return response;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};

export const APIUploadDocument = async (token, formData) => {
  try {
    const response = await axios.post(`${API_URL}/documents/upload/`, formData, {
      headers: { 'Authorization': `Bearer ${token}`, 'Content-Type': 'multipart/form-data' },
    });
    return response.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};

export const APIDeleteDocument = async (token, docId) => {
  try {
    const response = await axios.delete(`${API_URL}/documents/${docId}/delete/`, getAuthConfig(token));
    return response.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};

export const APIUpdateDocument = async (token, docId, data) => {
  try {
    const response = await axios.put(`${API_URL}/documents/${docId}/update/`, data, getAuthConfig(token));
    return response.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};

export const APIGetDocumentCategories = async (token) => {
  try {
    const response = await axios.get(`${API_URL}/documents/categories/`, getAuthConfig(token));
    return response.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};

export const APICreateDocumentCategory = async (token, name) => {
  try {
    const response = await axios.post(`${API_URL}/documents/categories/create/`, { name }, getAuthConfig(token));
    return response.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};

export const APIGrantDocumentAccess = async (token, docId, email) => {
  try {
    const response = await axios.post(`${API_URL}/documents/${docId}/grant-access/`, { email }, getAuthConfig(token));
    return response.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};

// ===== Clinical Cases (Admin) =====

export const APIGetClinicalCases = async (token) => {
  try {
    const response = await axios.get(`${API_URL}/content/admin/clinical-cases/`, getAuthConfig(token));
    return response.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};

export const APIGetClinicalCaseDetail = async (token, caseId) => {
  try {
    const response = await axios.get(`${API_URL}/content/admin/clinical-cases/${caseId}/`, getAuthConfig(token));
    return response.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};

export const APICreateClinicalCase = async (token, caseData) => {
  try {
    const response = await axios.post(`${API_URL}/content/admin/clinical-cases/create/`, caseData, getAuthConfig(token));
    return response.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};

export const APIUpdateClinicalCase = async (token, caseId, caseData) => {
  try {
    const response = await axios.put(`${API_URL}/content/admin/clinical-cases/${caseId}/update/`, caseData, getAuthConfig(token));
    return response.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};

export const APIDeleteClinicalCase = async (token, caseId) => {
  try {
    const response = await axios.delete(`${API_URL}/content/admin/clinical-cases/${caseId}/delete/`, getAuthConfig(token));
    return response.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};

// ===== Clinical Cases Generator =====

export const APIGenerateClinicalCases = async (token, data) => {
  try {
    const response = await axios.post(`${API_URL}/generator/generate-clinical-cases/`, data, {
      ...getAuthConfig(token),
      timeout: 300000  // 5 minutes timeout for AI generation
    });
    return response.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};

export const APIImportClinicalCases = async (token, cases) => {
  try {
    const response = await axios.post(`${API_URL}/generator/import-clinical-cases/`, { cases }, getAuthConfig(token));
    return response.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};

// ===== Reviews =====

export const APISubmitReview = async (token, data) => {
    try {
        const response = await axios.post(`${API_URL}/reviews/`, data, getAuthConfig(token));
        return response.data;
    } catch (error) {
        handleApiError(error);
        throw error;
    }
};

export const APIGetMyReview = async (token) => {
    try {
        const response = await axios.get(`${API_URL}/reviews/my/`, getAuthConfig(token));
        return response.data;
    } catch (error) {
        handleApiError(error);
        throw error;
    }
};

export const APIGetAdminReviews = async (token) => {
    try {
        const response = await axios.get(`${API_URL}/reviews/admin/`, getAuthConfig(token));
        return response.data;
    } catch (error) {
        handleApiError(error);
        throw error;
    }
};

// ===== Вспомогательные функции =====

// Обработка ошибок API
const handleApiError = (error) => {
  if (error.code === 'ECONNABORTED') {
    console.error('Запрос превысил лимит ожидания.');
  } else if (error.code === 'ERR_NETWORK') {
    console.error('Ошибка сети.');
  } else if (error.response) {
    // Ошибка с ответом от сервера
    console.error('Ошибка сервера:', error.response.status, error.response.data);
  } else {
    console.error('Произошла ошибка:', error.message);
  }
};

// Создание конфигурации axios с токеном авторизации
export const getAuthConfig = (token) => ({
  headers: {
    'Authorization': `Bearer ${token}`,
    'Content-Type': 'application/json'
  }
});

// ======= Study Plans =======

export const APIGetPlans = async (token) => {
    try {
        const response = await axios.get(`${API_URL}/plans/`, getAuthConfig(token));
        return response.data;
    } catch (error) {
        handleApiError(error);
        throw error;
    }
};

export const APIGetPlanDetail = async (token, planId) => {
    try {
        const response = await axios.get(`${API_URL}/plans/${planId}/`, getAuthConfig(token));
        return response.data;
    } catch (error) {
        handleApiError(error);
        throw error;
    }
};

export const APIEnrollPlan = async (token, planId) => {
    try {
        const response = await axios.post(`${API_URL}/plans/${planId}/enroll/`, {}, getAuthConfig(token));
        return response.data;
    } catch (error) {
        handleApiError(error);
        throw error;
    }
};

export const APIStartStepTest = async (token, stepId) => {
    try {
        const response = await axios.post(`${API_URL}/plans/steps/${stepId}/start-test/`, {}, getAuthConfig(token));
        return response.data;
    } catch (error) {
        handleApiError(error);
        throw error;
    }
};

export const APIMarkLectureViewed = async (token, stepId) => {
    try {
        const response = await axios.post(`${API_URL}/plans/steps/${stepId}/mark-lecture/`, {}, getAuthConfig(token));
        return response.data;
    } catch (error) {
        handleApiError(error);
        throw error;
    }
};

// ======= Study Plan Engine V2 =======

export const APIGetRoadmap = async (token) => {
    try {
        const response = await axios.get(`${API_URL}/plans/v2/roadmap/`, getAuthConfig(token));
        return response.data;
    } catch (error) {
        handleApiError(error);
        throw error;
    }
};

export const APIGetRoadmaps = async (token) => {
    try {
        const response = await axios.get(`${API_URL}/plans/v2/roadmaps/`, getAuthConfig(token));
        return response.data;
    } catch (error) {
        handleApiError(error);
        throw error;
    }
};

export const APIEnrollRoadmap = async (token, roadmapId) => {
    try {
        const response = await axios.post(`${API_URL}/plans/v2/enroll/`, { roadmap_id: roadmapId }, getAuthConfig(token));
        return response.data;
    } catch (error) {
        handleApiError(error);
        throw error;
    }
};

export const APIGetPlanModuleDetail = async (token, moduleId) => {
    try {
        const response = await axios.get(`${API_URL}/plans/v2/modules/${moduleId}/`, getAuthConfig(token));
        return response.data;
    } catch (error) {
        handleApiError(error);
        throw error;
    }
};

export const APICompleteTask = async (token, taskId) => {
    try {
        const response = await axios.post(`${API_URL}/plans/v2/tasks/${taskId}/complete/`, {}, getAuthConfig(token));
        return response.data;
    } catch (error) {
        handleApiError(error);
        throw error;
    }
};

export const APIUncompleteTask = async (token, taskId) => {
    try {
        const response = await axios.post(`${API_URL}/plans/v2/tasks/${taskId}/uncomplete/`, {}, getAuthConfig(token));
        return response.data;
    } catch (error) {
        handleApiError(error);
        throw error;
    }
};

export const APIStartPlanTest = async (token, taskId) => {
    try {
        const response = await axios.post(`${API_URL}/plans/v2/tasks/${taskId}/start-test/`, {}, getAuthConfig(token));
        return response.data;
    } catch (error) {
        handleApiError(error);
        throw error;
    }
};

export const APIGetToday = async (token) => {
    try {
        const response = await axios.get(`${API_URL}/plans/v2/today/`, getAuthConfig(token));
        return response.data;
    } catch (error) {
        handleApiError(error);
        throw error;
    }
};

// ======= Admin - Study Plans =======

export const APIAdminGetPlans = async (token) => {
    try {
        const response = await axios.get(`${API_URL}/plans/admin/`, getAuthConfig(token));
        return response.data;
    } catch (error) {
        handleApiError(error);
        throw error;
    }
};

export const APIAdminCreatePlan = async (token, data) => {
    try {
        const response = await axios.post(`${API_URL}/plans/admin/create/`, data, getAuthConfig(token));
        return response.data;
    } catch (error) {
        handleApiError(error);
        throw error;
    }
};

export const APIAdminUpdatePlan = async (token, planId, data) => {
    try {
        const response = await axios.put(`${API_URL}/plans/admin/${planId}/update/`, data, getAuthConfig(token));
        return response.data;
    } catch (error) {
        handleApiError(error);
        throw error;
    }
};

export const APIAdminDeletePlan = async (token, planId) => {
    try {
        const response = await axios.delete(`${API_URL}/plans/admin/${planId}/delete/`, getAuthConfig(token));
        return response.data;
    } catch (error) {
        handleApiError(error);
        throw error;
    }
};

// ===== Mass Question Generator (qgen) =====

export const APIQgenListBatches = async (token) => {
    const response = await axios.get(`${API_URL}/qgen/batches/`, getAuthConfig(token));
    return response.data;
};

export const APIQgenBatchDetail = async (token, batchId) => {
    const response = await axios.get(`${API_URL}/qgen/batches/${batchId}/`, getAuthConfig(token));
    return response.data;
};

export const APIQgenDeleteBatch = async (token, batchId) => {
    const response = await axios.delete(`${API_URL}/qgen/batches/${batchId}/delete/`, getAuthConfig(token));
    return response.data;
};

export const APIQgenApproveQuestion = async (token, questionId) => {
    const response = await axios.post(`${API_URL}/qgen/questions/${questionId}/approve/`, {}, getAuthConfig(token));
    return response.data;
};

export const APIQgenRejectQuestion = async (token, questionId) => {
    const response = await axios.post(`${API_URL}/qgen/questions/${questionId}/reject/`, {}, getAuthConfig(token));
    return response.data;
};

export const APIQgenApproveAll = async (token, batchId) => {
    const response = await axios.post(`${API_URL}/qgen/batches/${batchId}/approve-all/`, {}, getAuthConfig(token));
    return response.data;
};

export const APIQgenImport = async (token, batchId) => {
    const response = await axios.post(`${API_URL}/qgen/batches/${batchId}/import/`, {}, getAuthConfig(token));
    return response.data;
};

export const APIQgenStats = async (token) => {
    const response = await axios.get(`${API_URL}/qgen/stats/`, getAuthConfig(token));
    return response.data;
};

// ======= Admin - Module Linking =======

export const APITogglePlanModule = async (token, moduleId) => {
    try {
        const response = await axios.post(`${API_URL}/plans/v2/modules/${moduleId}/toggle/`, {}, getAuthConfig(token));
        return response.data;
    } catch (error) {
        handleApiError(error);
        throw error;
    }
};

export const APISearchModules = async (token, query) => {
    try {
        const response = await axios.get(`${API_URL}/modules/search/?q=${encodeURIComponent(query)}`, getAuthConfig(token));
        return response.data;
    } catch (error) {
        handleApiError(error);
        throw error;
    }
};

export const APISearchModulesContent = async (token, query) => {
    try {
        const response = await axios.get(`${API_URL}/modules/search-content/?q=${encodeURIComponent(query)}`, getAuthConfig(token));
        return response.data;
    } catch (error) {
        return { success: false, ids: [] };
    }
};

export const APILinkTaskModules = async (token, taskId, moduleIds) => {
    try {
        const response = await axios.put(`${API_URL}/plans/v2/tasks/${taskId}/link-modules/`, { module_ids: moduleIds }, getAuthConfig(token));
        return response.data;
    } catch (error) {
        handleApiError(error);
        throw error;
    }
};

export const APIUpdateTask = async (token, taskId, data) => {
    try {
        const response = await axios.put(`${API_URL}/plans/v2/tasks/${taskId}/update/`, data, getAuthConfig(token));
        return response.data;
    } catch (error) {
        handleApiError(error);
        throw error;
    }
};

export const APIAddTask = async (token, dayId, data) => {
    try {
        const response = await axios.post(`${API_URL}/plans/v2/days/${dayId}/add-task/`, data, getAuthConfig(token));
        return response.data;
    } catch (error) {
        handleApiError(error);
        throw error;
    }
};

export const APIDeletePlanTask = async (token, taskId) => {
    try {
        const response = await axios.delete(`${API_URL}/plans/v2/tasks/${taskId}/delete/`, getAuthConfig(token));
        return response.data;
    } catch (error) {
        handleApiError(error);
        throw error;
    }
};

export const APIUpdateDay = async (token, dayId, data) => {
    try {
        const response = await axios.put(`${API_URL}/plans/v2/days/${dayId}/update/`, data, getAuthConfig(token));
        return response.data;
    } catch (error) {
        handleApiError(error);
        throw error;
    }
};